import { render, staticRenderFns } from "./projectkEdit.vue?vue&type=template&id=618a7224"
import script from "./projectkEdit.vue?vue&type=script&lang=js"
export * from "./projectkEdit.vue?vue&type=script&lang=js"
import style0 from "./projectkEdit.vue?vue&type=style&index=0&id=618a7224&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports